import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import sanitizeHtml from 'sanitize-html';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { TextBreak } from 'fable/flowEditor/components/flowManager/canvas/node/textBreak';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { InputModal } from '../components/inputModal';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId,
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
const translateScopeVariables = (node) => {
    const { fieldLabel } = node.payload || {};
    const grants = fieldLabel ? [fieldLabel] : [];
    return {
        grants,
        needs: [],
    };
};
export const InputNodeAttributes = {
    iconName: 'input',
    label: 'Input',
    color: hexStringToNumber(flowNodeColor.orange),
    translatePayload,
    updateConnection,
    translateScopeVariables,
    NodeContent: InputNode,
    ActionModal: InputModal,
    helpText: 'Ask for user input like Order ID, Account Number, Shoe Size etc',
};
export function InputNode({ node }) {
    const { payload } = node;
    const { message } = payload;
    const sanitizedHtmlMessage = sanitizeHtml(message, {
        /*
         * What's the point of having tags if canvas can't display them?
         */
        allowedTags: [],
    });
    return (_jsx(TextContent, Object.assign({ maxLines: 1 }, { children: useMemo(() => (_jsx(TextBreak, { children: _jsx(Text, { weight: "normal", text: sanitizedHtmlMessage }) })), [sanitizedHtmlMessage]) })));
}
